export default __webpack_public_path__ + "static/media/H1015.4.60c5af41.mp3";